import React from 'react';
import { CloseOutlined, WarningFilled } from '@ant-design/icons';
import { BaseAlertBanner } from '@components';
import { AbsoluteWrapper as Wrapper } from '@components/alert-banner/styled.tsx';
import { useAppDispatch } from '@hooks/reduxHooks.ts';
import { useCustomNavigate } from '@hooks/useCustomNavigate.ts';
import { useLingui } from '@lingui/react/macro';
import { ROUTES } from '@router/constants.ts';
import { setShowDeactivateSubscriptionErrorBanner } from '@routes/sidebar/admin-center/tenant-client/___pages___/subscriptions/model/subscriptions.slice.ts';
import {
    SHARED_SUBSCRIPTION_DEACTIVATION_ERROR_ACTIVE_REQUIREMENTS,
    SHARED_SUBSCRIPTION_DEACTIVATION_ERROR_LINK,
    SHARED_SUBSCRIPTION_DEACTIVATION_ERROR_TITLE,
} from '@routes/sidebar/admin-center/tenant-client/___pages___/subscriptions/ui/table/subscription-deactivation-error/constants.ts';
import {
    Description,
    LearningRequirementsLink,
} from '@routes/sidebar/admin-center/tenant-client/___pages___/subscriptions/ui/table/subscription-deactivation-error/styled.tsx';
import { translateItem } from '@utils/translations.ts';

export const SubscriptionDeactivationErrorBanner: React.FC = () => {
    const { t } = useLingui();
    const navigate = useCustomNavigate();
    const dispatch = useAppDispatch();

    const handleLinkClick = () => {
        dispatch(setShowDeactivateSubscriptionErrorBanner(false));

        const { SUBSCRIPTIONS, MATRICES } = ROUTES.SIDEBAR.ADMIN;
        const nextPath = window.location.pathname.replace(SUBSCRIPTIONS, MATRICES);

        navigate(nextPath, { absolute: true });
    };

    const handleOnClose = () => {
        dispatch(setShowDeactivateSubscriptionErrorBanner(false));
    };

    return (
        <Wrapper $width={'30%'}>
            <BaseAlertBanner
                closable={{
                    onClose: handleOnClose,
                    closeIcon: <CloseOutlined />,
                }}
                type="error"
                title={translateItem(SHARED_SUBSCRIPTION_DEACTIVATION_ERROR_TITLE)}
                description={
                    <>
                        <Description>
                            <p>{translateItem(SHARED_SUBSCRIPTION_DEACTIVATION_ERROR_ACTIVE_REQUIREMENTS)}</p>
                            <p>
                                {t`Please reset or remove the requirements from the Learning Requirements page before
                            deactivating the subscription.`}
                            </p>
                        </Description>
                        <LearningRequirementsLink onClick={handleLinkClick}>
                            {translateItem(SHARED_SUBSCRIPTION_DEACTIVATION_ERROR_LINK)}
                        </LearningRequirementsLink>
                    </>
                }
                icon={<WarningFilled />}
            />
        </Wrapper>
    );
};
